<template>
    <div class="manuel-ban-modal wrapper">
        <Modal2
            v-if="internalBanModalVisible"
            class="ban-modal"
            :title="$t('message.banModalTitle')"
            @cancel="closeModal"
            @ok="suppressionProcess(type, value)"
        >
            <table class="ban-table">
                <thead>
                    <tr>
                        <th>{{ $t("message.platform") }}</th>
                        <th>{{ $t("chatbotv2.value") }}</th>
                        <th>{{ $t("message.sendingAllow") }}</th>
                        <th>{{ $t("message.receiving") }}</th>
                    </tr>
                </thead>
                <tr class="manual-ban-row">
                    <td>
                        <a-select id="type" v-model="type" v-validate="'required'" class="manual-ban-select">
                            <a-select-option v-for="t in types" :key="t">{{ t }} </a-select-option>
                        </a-select>
                    </td>
                    <td>
                        <input type="text" class="value-input" v-model="value" />
                    </td>
                    <td>
                        <a-switch
                            class="ml-2 mr-2"
                            un-checked-children="✔"
                            checked-children="✖"
                            @change="this.inbound = !this.inbound"
                            v-model="inbound"
                        />
                    </td>
                    <td>
                        <a-switch
                            class="ml-2 mr-2"
                            un-checked-children="✔"
                            checked-children="✖"
                            @change="this.outbound = !this.outbound"
                            v-model="outbound"
                        />
                    </td>
                </tr>
            </table>
        </Modal2>
    </div>
</template>
<script>
import Modal2 from "./common/Modal2.vue";
import { SUPPRESSION_API } from "../api/suppression";
import { mapState } from "vuex";
import SupsisButton from "./common/SupsisButtonOld.vue";

export default {
    name: "VisitorManualBanModal",
    components: { Modal2, SupsisButton },
    props: {
        banModalVisible: {
            type: Boolean,
        },
    },
    data() {
        return {
            internalBanModalVisible: false,
            types: ["email", "whatsapp", "web-visitor", "web-visitor-id"],
            type: "",
            value: "",
            inbound: false,
            outbound: false,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        resetForm() {
            this.type = "";
            this.value = "";
            this.inbound = false;
            this.outbound = false;
        },
        suppressionProcess(type, value) {
            if (!this.inbound && !this.outbound) {
                this.$toasted.error(this.$t("chatbotv2.didntSuppression"), {
                    duration: 3000,
                    position: "bottom-center",
                    className: ["yellow-toast"],
                    icon: "warning",
                });
            } else {
                if (!type || !value) {
                    this.$toasted.error(this.$t("chatbotv2.inputsCantBeEmpty"), {
                        duration: 3000,
                        position: "bottom-center",
                        icon: "error",
                    });
                    return;
                }

                SUPPRESSION_API.update(type, value, this.inbound, this.outbound, this.user._id);
                this.$emit("update");
                this.$message.success({
                    content: this.$t("chatbotv2.suppressionAdded"),
                    duration: 2,
                    key: "saved",
                });
                this.resetForm();
                this.closeModal();
            }
        },
        closeModal() {
            this.internalBanModalVisible = false;
            this.$emit("close");
        },
    },
    watch: {
        banModalVisible: {
            immediate: true,
            handler(val) {
                this.internalBanModalVisible = val;
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.manual-ban-select {
    width: 120px;
}
.value-input {
    width: 250px;
    border: 0.5px solid gray;
    margin: 10px !important;
    border-radius: 5px !important;
}
.supsis-logo {
    width: 42px !important;
    height: 42px !important;
    object-fit: contain;
}
</style>
<style>
.ban-modal {
    .ant-modal {
        width: max-content !important;
        z-index: 3000;
    }
    .supsis-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 25px;
        cursor: pointer;
    }
}
.toasted-container {
    z-index: 9999999999999 !important;
}
.yellow-toast {
    background-color: #ff9700 !important;
    color: white !important;
}
</style>
